import { Palette } from '@mui/material'

export const breadCrumbStyles = (palette: Palette) => ({
	display: 'flex',
	justifyContent: 'center',
	columnGap: '16px',
	color: palette.text.darkGrey,
})

export const campaignsBreadCrumbStyle = (palette: Palette) => ({
	display: 'flex',
	justifyContent: 'center',
	columnGap: '16px',
	marginRight: '14px',
	cursor: 'pointer',
	color: palette.text.darkGrey,
	'&:hover': {
		textDecoration: 'underline',
	},
})

export const locationBreadCrumbStyle = (palette: Palette) => ({
	display: 'flex',
	justifyContent: 'center',
	columnGap: '16px',
	marginLeft: '14px',
	color: palette.text.darkGrey,
})
